const YOUTUBE_VIDEO_ID = /^[A-Za-z0-9_-]{6,64}$/;

function cleanVideoId(value) {
  const id = String(value || "").trim();
  return YOUTUBE_VIDEO_ID.test(id) ? id : "";
}

function toUrl(value) {
  const raw = String(value || "").trim();
  if (!raw) return null;

  try {
    return new URL(/^https?:\/\//i.test(raw) ? raw : `https://${raw}`);
  } catch {
    return null;
  }
}

export function extractYouTubeVideoId(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";

  if (!raw.includes("/") && !raw.includes(".") && cleanVideoId(raw)) {
    return raw;
  }

  const url = toUrl(raw);
  if (!url) return "";

  const host = url.hostname.toLowerCase().replace(/^www\./, "");
  const parts = url.pathname.split("/").filter(Boolean);

  if (host === "youtu.be") {
    return cleanVideoId(parts[0]);
  }

  if (
    host === "youtube.com" ||
    host === "m.youtube.com" ||
    host === "music.youtube.com" ||
    host === "youtube-nocookie.com"
  ) {
    const queryId = url.searchParams.get("v");
    if (queryId) return cleanVideoId(queryId);

    if (["embed", "shorts", "live", "v"].includes(parts[0])) {
      return cleanVideoId(parts[1]);
    }
  }

  return "";
}

export function isValidYouTubeUrl(value) {
  return Boolean(extractYouTubeVideoId(value));
}

export function getYouTubeEmbedUrl(value) {
  const id = extractYouTubeVideoId(value);
  return id ? `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?rel=0` : "";
}

export function getYouTubeThumbnailUrl(value, quality = "maxresdefault") {
  const id = extractYouTubeVideoId(value);
  return id ? `https://img.youtube.com/vi/${encodeURIComponent(id)}/${quality}.jpg` : "";
}

export function getYouTubeWatchUrl(value) {
  const id = extractYouTubeVideoId(value);
  return id ? `https://www.youtube.com/watch?v=${encodeURIComponent(id)}` : "";
}
